module.exports = __webpack_public_path__ + "img/side-image-bank.d8508449.jpg";